import * as types from './constants'
import apiService from '../../apiService/apiService'
import {
    toFabrics,
    toComments,
    toPlan,
    toPlans,
    toPlanProfile,
    toFabric,
    toFilters,
} from '../../mapper/planMapper'
import { toast } from 'react-toastify'

export const getPlans = ({
    type,
    sort,
    filter,
    search,
    pageNumber,
    replace,
}) => {
    return (dispatch, getState) => {
        let oldPlans = getState().plan.plans
        if (replace) oldPlans = []
        dispatch({
            type: types.GET_PLANS_START,
        })
        apiService.plan
            .getAll({ type, sort, filter, search, pageNumber })
            .then((response) => {
                if (response.status == 200) {
                    const plans = response.data

                    dispatch({
                        type: types.GET_PLANS_SUCCESS,
                        payload: [...oldPlans, ...toPlans(plans)],
                    })
                } else {
                    dispatch({
                        type: types.GET_PLANS_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLANS_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const resetPlans = () => {
    return (dispatch) =>
        dispatch({
            type: types.RESET_PLANS,
        })
}

export const getPlan = (planId) => {
    return (dispatch) => {
        dispatch({
            type: types.GET_PLAN_START,
        })
        apiService.plan
            .getById(planId)
            .then((response) => {
                if (response.status == 200) {
                    const plan = response.data
                    dispatch({
                        type: types.GET_PLAN_SUCCESS,
                        payload: toPlan(plan),
                    })
                    dispatch({
                        type: types.GET_PLAN_COMMENTS_SUCCESS,
                        payload: toComments(plan.comments),
                    })
                    const fabrics = toFabrics(plan.usedFabrics)
                    dispatch({
                        type: types.GET_PLAN_FABRICS_SUCCESS,
                        payload: fabrics,
                    })
                    dispatch(getPlanFabrics(fabrics))
                    console.log('toPlanProfile(plan)', toPlanProfile(plan))
                    dispatch({
                        type: types.GET_PLAN_PROFILE_SUCCESS,
                        payload: toPlanProfile(plan),
                    })
                } else {
                    dispatch({
                        type: types.GET_PLAN_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLAN_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const getFilters = () => {
    return (dispatch) => {
        dispatch({
            type: types.GET_PLAN_FILTERS_START,
        })
        apiService.plan
            .getFilters()
            .then((response) => {
                if (response.status == 200) {
                    const filters = response.data

                    dispatch({
                        type: types.GET_PLAN_FILTERS_SUCCESS,
                        payload: toFilters(filters),
                    })
                } else {
                    dispatch({
                        type: types.GET_PLAN_FILTERS_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLAN_FILTERS_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const getPlanFabrics = (fabrics) => {
    return (dispatch, getState) => {
        fabrics.forEach((fabric, index) => {
            if (index === 0)
                dispatch({
                    type: types.GET_PLAN_FABRICS_START,
                })

            apiService.plan
                .getFabricsById(fabric.id)
                .then((response) => {
                    if (response.status == 200) {
                        const fabric = response.data

                        dispatch({
                            type: types.GET_PLAN_FABRICS_SUCCESS,
                            payload: getState()
                                .plan.planFabrics.filter(
                                    (q) => q.id != fabric.id
                                )
                                .concat(toFabric(fabric)),
                        })
                    } else {
                        dispatch({
                            type: types.GET_PLAN_FABRICS_FAIL,
                            error:
                                response.data.message ||
                                response.data.errors[0].description,
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                    let errorMessage = error
                    if (error?.response?.data)
                        errorMessage = error.response.data
                    dispatch({
                        type: types.GET_PLAN_FABRICS_FAIL,
                        error: errorMessage,
                    })
                })
        })
    }
}

export const toggleLike = (planId) => {
    return (dispatch, getState) => {
        const plans = getState().plan.plans

        const newPlans = plans.map((plan) => {
            if (plan.id === planId) {
                plan.isLiked = !plan.isLiked
                if (plan.isLiked) plan.likesCount++
                else plan.likesCount--
            }

            return plan
        })

        dispatch({
            type: types.GET_PLANS_SUCCESS,
            payload: newPlans,
        })

        apiService.plan
            .toggleLike(planId)
            .then(() => {
                toast.success('بازخورد شما با موفقیت ثبت شد')
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLAN_PROFILE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const toggleFavourite = (planId) => {
    return (dispatch, getState) => {
        const plans = getState().plan.plans

        const newPlans = plans.map((plan) => {
            if (plan.id === planId) plan.isFavourited = !plan.isFavourited

            return plan
        })

        dispatch({
            type: types.GET_PLANS_SUCCESS,
            payload: newPlans,
        })

        apiService.plan
            .toggleFavourite(planId)
            .then(() => {
                toast.success('بازخورد شما با موفقیت ثبت شد')
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLAN_PROFILE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const togglePublic = (planId, newValue) => {
    return (dispatch, getState) => {
        const plans = getState().plan.plans

        const newPlans = plans.map((plan) => {
            if (plan.id === planId) plan.isPublic = !plan.isPublic

            return plan
        })

        dispatch({
            type: types.GET_PLANS_SUCCESS,
            payload: newPlans,
        })

        apiService.plan
            .togglePublic(planId, newValue)
            .then(() => {
                toast.success('تغییر درخواستی شما با موفقیت ثبت شد')
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PLAN_PROFILE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const updatePlan = (plan) => {
    return (dispatch) => {
        dispatch({
            type: types.UPDATE_PLAN,
            payload: plan,
        })
    }
}

export const addComment = (planId, comment) => {
    return (dispatch) => {
        apiService.plan
            .addComment(planId, comment)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.ADD_COMMENT_START,
                    })
                    toast.success('نظر شما با موفقیت ثبت شد')
                    dispatch(getPlan(planId))
                } else {
                    dispatch({
                        type: types.ADD_COMMENT_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.ADD_COMMENT_FAIL,
                    error: errorMessage,
                })
            })
    }
}
